<template>
    <!-- https://demo.qwik-orderplus.com/RevolutionSlider/index.html -->
    <iframe :src="slider_url" id="revSlider">
    </iframe>
</template>

<style scoped>
    #revSlider{
        width: 100%;
        height: 525px;
        overflow: hidden;
        /* width: 100%;
        height: 100%; */
        border-width: 0px;
    }
    @media screen and (max-width: 1024px){
        #revSlider{
            height: 384px;
        }
    }
    @media screen and (max-width: 777px){
        #revSlider{
            height: 860px;
        }
    }
    @media screen and (max-width: 480px){
        #revSlider{
            height: 531px;
        }
    }
</style>
<script>

    export default {
        data() {
            return {
                // https://demo3.qwik-orderplus.com/RevolutionSlider/index.html
                slider_url: '',
            }
        },
        watch: {
            slider_url(newVal){
                console.log('new value = ' + newVal);
                // this.colorAnalysis = this.$props.config;
            },
        },
        beforeUnmount(){
            // const revslider41 = window.RS_MODULES.modules["revslider41"];
            // revslider41.destroy(); 
        },

        mounted () {
            setTimeout(() => {
                // get slider URL from the state
                this.slider_url = this.$store.getters['slider_url'];
            }, 500);
        }
    }
</script>